var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.286 23.128H1.714V2.556h6.857V7.7a1.72 1.72 0 001.715 1.714h5.142v2.572h1.715V7.699a.78.78 0 00-.258-.6l-6-6a.78.78 0 00-.6-.257h-8.57A1.72 1.72 0 000 2.556v20.572a1.72 1.72 0 001.714 1.714h8.572v-1.714zm0-20.229l4.8 4.8h-4.8V2.9z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.143 15.413l-1.212 1.212 2.216 2.216h-7.004v1.715h7.004l-2.216 2.216 1.212 1.212 4.285-4.286-4.285-4.285z",
    fill: "#ED1B2E"
  })));
}

export default SvgStatusEnd;